import React, { ReactNode } from "react";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  showCancelBtn?: boolean;
  top?: boolean;
  children: ReactNode;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  showCancelBtn = true,
  onClose,
  top,
  children,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex justify-center items-start sm:items-center overflow-y-auto">

      <div className={`relative w-full max-w-[732px] mx-auto my-10 bg-white rounded-lg shadow-lg ${top && 'top-[42%]'}`}>
        {/* Close Button */}
        {showCancelBtn && (
          <button
            onClick={onClose}
            className="absolute top-3 right-3 z-50 bg-white text-black h-8 w-8 rounded-full flex items-center justify-center shadow-md"
          >
            ×
          </button>
        )}
        {/* Modal Content */}
        {children}
      </div>
    </div>
  );
};

export default Modal;
